import {ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {ReactBaseComponent} from '../../../../react/base/react-base.component';
import {BusinessOrderStartErrors} from '../../../../react/workflow/business-order/start/business-order-start-errors';
import {RightService} from '../../../../common/right-service/right.service';
import {
  BusinessOrderStartErrorFetch,
} from '../../../../react/workflow/business-order/start/business-order-start-error-fetches.model';

const containerElementName = 'reactBusinessOrderStartErrors';

@Component({
  selector: 'business-order-start-errors',
  template: `<div #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class BusinessOrderStartErrorsReactComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() errors: string[] = [];
  @Input() errorFetches: BusinessOrderStartErrorFetch[] = [];

  constructor(private rightService: RightService) {
    super();
  }

  protected override renderComponent() {
    return <BusinessOrderStartErrors errors={this.errors}
                                     errorFetches={this.errorFetches}
                                     canViewWorkflow={this.rightService.has('task.view')}/>;
  }
}
